import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter, createChainHandler } from "@store/Modules/client-framework/HandlerCreator";

export const SetCartNotes = createChainHandler("SetCartNotes", chain, props => {
    if (props.cartToUpdate && !props.cartToUpdate.notes) {
        props.cartToUpdate.notes = props.getState().pages.checkoutShipping.editedCartNotes ?? "";
    }
});

addToChainAfter(chain, SetCartStatus, SetCartNotes);
